import { supabase } from "@/integrations/supabase/client";
import { Assessment } from "@/types/assessment";
import { getAssessmentById } from "./getAssessments";

// Archive an assessment
export const archiveAssessment = async (id: string): Promise<Assessment | null> => {
  try {
    const { error } = await supabase
      .from("assessments")
      .update({
        is_active: false,
        status: "archived",
        updated_at: new Date().toISOString(),
      })
      .eq("id", id);

    if (error) {
      console.error("Error archiving assessment:", error);
      throw error;
    }

    return await getAssessmentById(id);
  } catch (error) {
    console.error("Error in archiveAssessment:", error);
    throw error;
  }
};

// Restore an archived assessment
export const restoreArchivedAssessment = async (id: string): Promise<Assessment | null> => {
  try {
    const currentAssessment = await getAssessmentById(id);
    if (!currentAssessment || currentAssessment.status !== "archived") {
      return null;
    }

    const { error } = await supabase
      .from("assessments")
      .update({
        is_active: true,
        status: "published",
        updated_at: new Date().toISOString(),
      })
      .eq("id", id);

    if (error) {
      console.error("Error restoring assessment:", error);
      throw error;
    }

    return await getAssessmentById(id);
  } catch (error) {
    console.error("Error in restoreArchivedAssessment:", error);
    throw error;
  }
};
